// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({448: "shaka",586: "recorder",621: "profiler",}[chunkId] || chunkId) + "." + {231: "1a8454e7a8",273: "a7af080541",4: "affe568e30",448: "a195fa7673",523: "e739e100a6",571: "a0d9ce179e",586: "7f50a412e7",621: "e473755e01",645: "770c771ae9",79: "a7472ea7a7",882: "60f6a85e4d",904: "b5d5d9f35a",91: "4891ff9d29",928: "ce68a05f0c",}[chunkId] + ".js"
}